import React from "react";
import COLORS from "../../constants/colors";
import {
  mainCardStyle,
  pageStyle,
  primaryBtnStyle,
} from "../../styles/commonStyles";

export default function CompleteCard({
  emoji = "✨",
  title,
  desc,
  buttonText = "返回主页",
  onClick,
  children,
}) {
  return (
    <div style={pageStyle()}>
      <div style={mainCardStyle()}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "2.6rem" }}>{emoji}</div>

          <div
            style={{
              fontSize: "1.7rem",
              fontWeight: 800,
              color: COLORS.text,
              marginTop: "0.6rem",
            }}
          >
            {title}
          </div>

          <div
            style={{
              color: COLORS.subtext,
              marginTop: "0.8rem",
              lineHeight: 1.8,
            }}
          >
            {desc}
          </div>

          {children}

          <button
            onClick={onClick}
            style={{
              ...primaryBtnStyle(),
              marginTop: "1.4rem",
              width: "100%",
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}